import './FAQStyles.css';

import AccordionItem from '@/components/ui/AccordionItem';

export const FAQView = ({ faqItems, openId, onToggleQuestion }) => {
  return (
    <section className="faq-section">
      <div className="faq-container">
        {/* Header */}
        <div className="faq-header">
          <h1 className="faq-title">Perguntas Frequentes</h1>
          <p className="faq-subtitle">
            Encontre respostas para as dúvidas mais comuns sobre o Lily Book
            Club
          </p>
        </div>

        {/* Accordion */}
        <div className="faq-accordion">
          {faqItems.map((item) => (
            <AccordionItem
              key={item.id}
              id={item.id}
              title={item.pergunta}
              isOpen={openId === item.id}
              onToggle={() => onToggleQuestion(item.id)}
            >
              {item.resposta}
            </AccordionItem>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQView;
